import { createSlice } from "@reduxjs/toolkit"
import { InvitationsState } from "./types"
import { ErrorType } from "@/shared/types"
import { fetchEmployeesInvitations, fetchInvitations, fetchUsersInvitations } from "./invitations-thunk"

const initialState: InvitationsState = {
    invitations: [],
    invitationsFirstLoad: true,
    usersInvitations: [],
    usersInvitationsError: null,
    isUsersInvitationsLoading: false,
    isUsersInvitationsFirstLoad: true,
    employeesInvitations: [],
    employeesInvitationsError: null,
    isEmployeesInvitationsLoading: false,
    isEmployeesInvitationsFirstLoad: true
}

const invitationsSlice = createSlice({
    name: 'invitations',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
        .addCase(fetchEmployeesInvitations.pending, (state) => {
            state.employeesInvitationsError = null
            state.isEmployeesInvitationsLoading = true
        })
        .addCase(fetchEmployeesInvitations.fulfilled, (state, action) => {
            state.employeesInvitationsError = null
            state.isEmployeesInvitationsFirstLoad = false
            state.isEmployeesInvitationsLoading = false
            state.employeesInvitations = action.payload
        })
        .addCase(fetchEmployeesInvitations.rejected, (state, action) => {
            state.employeesInvitationsError = action.payload as ErrorType ?? null
            state.isEmployeesInvitationsLoading = false
        })
        .addCase(fetchUsersInvitations.pending, (state) => {
            state.usersInvitationsError = null
            state.isUsersInvitationsLoading = true
        })
        .addCase(fetchUsersInvitations.fulfilled, (state, action) => {
            state.usersInvitationsError = null
            state.isUsersInvitationsFirstLoad = false
            state.isUsersInvitationsLoading = false
            state.usersInvitations = action.payload
        })
        .addCase(fetchUsersInvitations.rejected, (state, action) => {
            state.usersInvitationsError = action.payload as ErrorType ?? null
            state.isUsersInvitationsLoading = false
        })
        .addCase(fetchInvitations.fulfilled, (state, action) => {
            state.invitations = action.payload
            state.invitationsFirstLoad = false
        })
    },
})

export default invitationsSlice.reducer
export const {} = invitationsSlice.actions